import AuthHeader from "./AuthHeader";
import WERIHeader from "./containers/WERIHeader";

export default process.env.NEXT_PUBLIC_APP_WL_CODE === "WERI" ? WERIHeader : AuthHeader;
